/**
 * Extracts the child key from an event property rule string. The string should contain at most one instance of
 * children[<childKey>].
 */
export const extractChildKeyFromString = (value: string) => {
  const matches = value.match(/children\[(.+?)]/);
  return matches?.length === 2 ? matches[1] : undefined;
};
